import { getFileExtensionGivenFile } from './media';

export default function getVideoThumbnailOrPoster(file: File, isPoster: boolean) {
	return new Promise((resolve, reject) => {
		try {
			const url = URL.createObjectURL(file);
			const videoEl = document.createElement('video');
			videoEl.src = url;
			videoEl.muted = true;

			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			videoEl.addEventListener('playing', () => {
				// For a thumbnail we want an image from the middle of the video duration (in case the start of the video is black).
				// For a video poster we want the first frame as it's displayed while the video loads and transitions into it playing.
				videoEl.currentTime = isPoster ? 0 : videoEl.duration / 1.5;
			});

			videoEl.addEventListener('seeked', () => {
				canvas.width = videoEl.videoWidth;
				canvas.height = videoEl.videoHeight;
				ctx?.drawImage(videoEl, 0, 0, videoEl.videoWidth, videoEl.videoHeight);
				const videoExtension = getFileExtensionGivenFile(file);
				// For video posters we want the highest quality image to match the quality of the video when it begins playing for a smooth transition.
				const frame = canvas.toDataURL(`image/${videoExtension === 'webm' ? 'png' : 'jpeg'}`, isPoster ? 1 : 0.8);
				resolve(dataURItoBlob(frame));
				videoEl.pause();
				videoEl.remove();
				canvas.remove();
			});

			videoEl.play();
		} catch (e) {
			reject(e);
		}
	});
}

function dataURItoBlob(dataURI: string) {
	// convert base64/URLEncoded data component to raw binary data held in a string
	let byteString;
	if (dataURI.split(',')[0].indexOf('base64') >= 0)
		byteString = atob(dataURI.split(',')[1]);
	else
		byteString = unescape(dataURI.split(',')[1]);

	// separate out the mime component
	const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	// write the bytes of the string to a typed array
	const ia = new Uint8Array(byteString.length);
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	return new Blob([ia], { type: mimeString });
}